import { render, staticRenderFns } from "./mail_home.vue?vue&type=template&id=6164b491&scoped=true&"
import script from "./mail_home.vue?vue&type=script&lang=js&"
export * from "./mail_home.vue?vue&type=script&lang=js&"
import style0 from "./mail_home.vue?vue&type=style&index=0&id=6164b491&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6164b491",
  null
  
)

component.options.__file = "mail_home.vue"
export default component.exports